import { useTranslation } from 'react-i18next';

import logowhite from '/logowhite.svg';

import { Link } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-primary bottom-0 w-full z-100">
      <div className="my-6 flex items-center justify-center md:flex-col">
        <img src={logowhite} />
      </div>
      <div className="border-b border-white mx-32 opacity-20 md:mx-10" />
      <div className="my-6 flex items-center justify-center">
        <div className="text-white underline cursor-pointer">
          <Link to="/privacy-policy">{t('privacyPolicy')}</Link>
        </div>
        <div className="ml-8 text-white underline cursor-pointer">
          <Link to="/terms-of-use">{t('termsOfUse')}</Link>
        </div>
        <button className="bg-primary underline cursor-pointer w-10 h-3"
          onClick={() => {
            throw new Error('This is your first error!');
          }}
        >
        </button>
      </div>
    </div>
  );
};

export default Footer;
